import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

/** Renders date-only content with the shared display format. */
@ngCore.Component({
  selector: 'atn-date-content',
  standalone: true,
  template: `{{ readableDateSg() }}`,
})
export class Component {
  /** @see {@link ents.core.common.value.Raw} */
  public readonly valueSg = ngCore.input<
    | ents.core.common.value.Raw<ents.core.common.value.types.Intrinsic.Date>
    | undefined
  >(undefined, {
    alias: 'value',
  })

  /** Formats date-only content for display. */
  public readonly readableDateSg = ngCore.computed(
    (value = this.valueSg()) => ents.core.display.date.format(value) ?? '',
  )
}
